import React from 'react';
import { Layout } from '../components/Layout/Layout';
import { PreSupabaseChecker } from '../components/Setup/PreSupabaseChecker';
import { SupabaseConnectionChecker } from '../components/Debug/SupabaseConnectionChecker';
import { AdminAccountsManager } from '../components/Debug/AdminAccountsManager';
import { TestDataManager } from '../components/Debug/TestDataManager';

export const SetupPage: React.FC = () => {
  return (
    <Layout>
      <div className="p-6">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Configuration et Setup</h1>
          <p className="text-gray-600">Vérifiez l'état de votre configuration Supabase</p>
        </div>
        
        <SupabaseConnectionChecker />
        <AdminAccountsManager />
        <TestDataManager />
      </div>
    </Layout>
  );
};